module.exports = {"lang":"CN","home":"Home","distanceTime":"To the WAIC open in {num} Days"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/languages/en.json
// module id = czGY
// module chunks = 20